/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Serve_Faq_1_AInputs */

const en_serve_faq_1_a = /** @type {(inputs: Serve_Faq_1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The helper only works inside one project folder on your computer and only does what Bystep's plan says. You see every step and its proof on Bystep, and you can stop at any time.`)
};

const id_serve_faq_1_a = /** @type {(inputs: Serve_Faq_1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asisten hanya bekerja di satu folder proyek di komputermu dan hanya mengerjakan yang tertulis di rencana Bystep. Setiap langkah dan buktinya terlihat di Bystep, dan kamu bisa berhenti kapan saja.`)
};

/**
* | output |
* | --- |
* | "The helper only works inside one project folder on your computer and only does what Bystep's plan says. You see every step and its proof on Bystep, and you c..." |
*
* @param {Serve_Faq_1_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const serve_faq_1_a = /** @type {((inputs?: Serve_Faq_1_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serve_Faq_1_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_serve_faq_1_a(inputs)
	return en_serve_faq_1_a(inputs)
});